import { render } from "./PriceHistoryChart.vue?vue&type=template&id=0e87fbd8&scoped=true"
import script from "./PriceHistoryChart.vue?vue&type=script&lang=js"
export * from "./PriceHistoryChart.vue?vue&type=script&lang=js"

import "./PriceHistoryChart.vue?vue&type=style&index=0&id=0e87fbd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e87fbd8"]])

export default __exports__